/**
 * It's not a bug, is a feature! :D
 * You must use a hook instead
 */
function HookUseImageUrlAdapter() {
  console.warn('Not meant to be used like this') // eslint-disable-line no-console
  return <div>Must use named import to use hooks</div>
}

HookUseImageUrlAdapter.displayName = 'HookUseImageUrlAdapter'

export default HookUseImageUrlAdapter
